import { useSuspenseQuery } from "@tanstack/react-query";

import {
  apiGetMedicaldataListOptions,
  type SupportedMedicalData,
} from "../api";
import { queryClient } from "../api/query-client";

/**
 * Supported-medical-data catalog — global reference data, fetched once per
 * session. `useSupportedMedicalData` for components (suspends until loaded);
 * `fetchSupportedMedicalData` for MobX models and route loaders.
 */
function supportedMedicalDataQuery() {
  return { ...apiGetMedicaldataListOptions(), staleTime: Infinity };
}

export function useSupportedMedicalData(): SupportedMedicalData[] {
  // Suspends the nearest boundary until loaded, so callers always get data.
  return useSuspenseQuery(supportedMedicalDataQuery()).data.medical_data;
}

export async function fetchSupportedMedicalData(): Promise<
  SupportedMedicalData[]
> {
  const { medical_data } = await queryClient.ensureQueryData(
    supportedMedicalDataQuery(),
  );
  return medical_data;
}
